// 24 questions for PLAY YOUR GAME™ test.
// Each option awards points to one of 4 avatars: leon | lobo | halcon | delfin
// Dominant = highest total. Secondary = second highest.

const L = "leon", W = "lobo", H = "halcon", D = "delfin";

export const ARCHETYPE_META = {
  leon: {
    code: "leon",
    name: "LEÓN",
    img: "https://customer-assets.emergentagent.com/job_strategic-evolution/artifacts/q43hc936_002-lion.png",
    tagline: "empuja y decide",
    color: "#FF6B4A",
    description:
      "Tu fuerza es la acción. Decides rápido, te lanzas y mueves a otros con tu energía. Bajo presión te aceleras: aprende a frenar para no atropellar lo que estás construyendo.",
  },
  lobo: {
    code: "lobo",
    name: "LOBO",
    img: "https://customer-assets.emergentagent.com/job_strategic-evolution/artifacts/q013w4ih_007-golden-wolf-1.png",
    tagline: "analiza y estructura",
    color: "#A78BFA",
    description:
      "Tu fuerza es el método. Observas, ordenas y construyes sistemas. Bajo presión te bloqueas analizando: aprende a decidir con información incompleta.",
  },
  halcon: {
    code: "halcon",
    name: "HALCÓN",
    img: "https://customer-assets.emergentagent.com/job_strategic-evolution/artifacts/btoarlhg_005-eagle-1.png",
    tagline: "ve y proyecta",
    color: "#29BC9B",
    description:
      "Tu fuerza es la visión. Ves el panorama, eliges lo esencial y descartas el ruido. Bajo presión te desconectas emocionalmente: aprende a bajar a tierra con los tuyos.",
  },
  delfin: {
    code: "delfin",
    name: "DELFÍN",
    img: "https://customer-assets.emergentagent.com/job_strategic-evolution/artifacts/nztl5ndq_004-dolphin-1.png",
    tagline: "conecta y alinea",
    color: "#5BC0EB",
    description:
      "Tu fuerza es la conexión. Lees personas, alineas equipos y construyes confianza. Bajo presión evitas la tensión necesaria: aprende a sostener el conflicto que hace evolucionar.",
  },
};

export const QUIZ_QUESTIONS = [
  { id: "q1", text: "Cuando piensas en tu futuro profesional…", options: [
    { text: "Quiero avanzar rápido.", code: L, points: 1 },
    { text: "Quiero hacerlo bien.", code: W, points: 1 },
    { text: "Quiero tomar buenas decisiones.", code: H, points: 1 },
    { text: "Quiero construir relaciones que generen oportunidades.", code: D, points: 1 },
  ]},
  { id: "q2", text: "Para mantener constancia, necesitas…", options: [
    { text: "Retos grandes que me exijan.", code: L, points: 1 },
    { text: "Sistemas claros que me ordenen.", code: W, points: 1 },
    { text: "Sentido y dirección clara.", code: H, points: 1 },
    { text: "Conectar con personas.", code: D, points: 1 },
  ]},
  { id: "q3", text: "Cuando trabajas solo…", options: [
    { text: "Avanzo rápido, pero me distraigo.", code: L, points: 1 },
    { text: "Me concentro bastante.", code: W, points: 1 },
    { text: "Avanzo si veo sentido.", code: H, points: 1 },
    { text: "Me cuesta más.", code: D, points: 1 },
  ]},
  { id: "q4", text: "En el día a día…", options: [
    { text: "Me guío por acción y avance.", code: L, points: 1 },
    { text: "Me guío por método y estructura.", code: W, points: 1 },
    { text: "Me guío por prioridades.", code: H, points: 1 },
    { text: "Me guío por cómo conecto con las personas.", code: D, points: 1 },
  ]},
  { id: "q5", text: "Te sientes más productivo cuando…", options: [
    { text: "Hay movimiento y estoy en acción.", code: L, points: 2 },
    { text: "Todo está ordenado y bajo control.", code: W, points: 1 },
    { text: "Tengo claro el objetivo y el enfoque.", code: H, points: 1 },
    { text: "Estoy interactuando y conectando con personas.", code: D, points: 1 },
  ]},
  { id: "q6", text: "Cuando tienes muchas cosas pendientes al mismo tiempo…", options: [
    { text: "Empiezo por alguna y avanzo rápido.", code: L, points: 1 },
    { text: "Intento ordenar todo antes de empezar.", code: W, points: 1 },
    { text: "Elijo solo lo más importante y dejo el resto.", code: H, points: 1 },
    { text: "Coordino con otros para avanzar.", code: D, points: 1 },
  ]},
  { id: "q7", text: "Para ti, el fracaso es…", options: [
    { text: "Parte del camino.", code: L, points: 1 },
    { text: "Entender qué falló en detalle.", code: W, points: 1 },
    { text: "Un dato para decidir mejor.", code: H, points: 1 },
    { text: "Mejorar cómo conecto con otros.", code: D, points: 1 },
  ]},
  { id: "q8", text: "Cuando te equivocas frente a otros…", options: [
    { text: "No me detiene mucho.", code: L, points: 1 },
    { text: "Me incomoda, pero aprendo.", code: W, points: 1 },
    { text: "Me importa si afecta el resultado.", code: H, points: 1 },
    { text: "Me importa si afecta la relación.", code: D, points: 1 },
  ]},
  { id: "q9", text: "Frente a la presión…", options: [
    { text: "Acelero y paso a la acción.", code: L, points: 1 },
    { text: "Me vuelvo más analítico y cuidadoso.", code: W, points: 1 },
    { text: "Me vuelvo más selectivo con mis decisiones.", code: H, points: 1 },
    { text: "Busco leer el ambiente y ajustar cómo interactúo.", code: D, points: 1 },
  ]},
  { id: "q10", text: "Cuando alguien te dice que no ahora…", options: [
    { text: "Busco otra oportunidad rápidamente.", code: L, points: 1 },
    { text: "Pregunto qué tendría que cambiar.", code: W, points: 1 },
    { text: "Analizo si ese “no” es definitivo.", code: H, points: 1 },
    { text: "Busco cómo conectar mejor, aunque tome tiempo.", code: D, points: 1 },
  ]},
  { id: "q11", text: "Si algo no sale como esperabas…", options: [
    { text: "Paso rápido a lo siguiente, aunque puedo dejar aprendizajes atrás.", code: L, points: 1 },
    { text: "Reviso en detalle qué pasó, aunque me quite tiempo para avanzar.", code: W, points: 1 },
    { text: "Evalúo si vale la pena insistir, aunque a veces cambio de enfoque rápido.", code: H, points: 2 },
    { text: "Busco entender cómo impactó en los demás, aunque luego me cueste soltarlo.", code: D, points: 1 },
  ]},
  { id: "q12", text: "Cuando recibes un “no”…", options: [
    { text: "Me dan más ganas de intentarlo.", code: L, points: 1 },
    { text: "Quiero entender el motivo real.", code: W, points: 1 },
    { text: "Lo tomo como información.", code: H, points: 2 },
    { text: "Busco mantener la puerta abierta.", code: D, points: 1 },
  ]},
  { id: "q13", text: "Cuando alguien no responde como esperabas…", options: [
    { text: "Insisto de otra forma.", code: L, points: 1 },
    { text: "Me pregunto qué no entendí.", code: W, points: 1 },
    { text: "Replanteo si vale la pena insistir.", code: H, points: 2 },
    { text: "Me cuestiono si conecté bien.", code: D, points: 2 },
  ]},
  { id: "q14", text: "En conversaciones largas…", options: [
    { text: "Busco mover la conversación hacia avance.", code: L, points: 1 },
    { text: "Me mantengo atento a los detalles, aunque tome más tiempo.", code: W, points: 1 },
    { text: "Me enfoco en lo importante y dejo lo demás.", code: H, points: 1 },
    { text: "Busco conectar y mantener la interacción activa.", code: D, points: 1 },
  ]},
  { id: "q15", text: "Cuando alguien duda frente a ti…", options: [
    { text: "Lo llevo a tomar una decisión.", code: L, points: 1 },
    { text: "Exploro la duda paso a paso.", code: W, points: 1 },
    { text: "Evalúo si realmente es el momento correcto.", code: H, points: 1 },
    { text: "Busco que se sienta cómodo para decidir.", code: D, points: 1 },
  ]},
  { id: "q16", text: "Cuando no estás de acuerdo con alguien en una conversación importante…", options: [
    { text: "Digo lo que pienso directamente.", code: L, points: 1 },
    { text: "Busco entender bien su punto antes de responder.", code: W, points: 1 },
    { text: "Evalúo si vale la pena entrar en la discusión.", code: H, points: 1 },
    { text: "Cuido cómo decirlo para no afectar la relación.", code: D, points: 1 },
  ]},
  { id: "q17", text: "En una conversación importante, te sientes más cómodo cuando…", options: [
    { text: "Tienes el control de la conversación.", code: L, points: 1 },
    { text: "Tienes información clara para avanzar.", code: W, points: 1 },
    { text: "Ves el objetivo final con claridad.", code: H, points: 1 },
    { text: "Hay buena conexión con la otra persona.", code: D, points: 1 },
  ]},
  { id: "q18", text: "Cuando hablas con alguien y la conversación se vuelve lenta…", options: [
    { text: "Tomo el control y empujo la conversación.", code: L, points: 1 },
    { text: "Hago preguntas para descubrir los detalles, aunque tome más tiempo.", code: W, points: 1 },
    { text: "Evalúo si conviene seguir o cerrar la conversación.", code: H, points: 1 },
    { text: "Cambio el tono para hacerla más cercana.", code: D, points: 1 },
  ]},
  { id: "q19", text: "Cuando entras a un entorno nuevo (trabajo, equipo, grupo)…", options: [
    { text: "Busco destacar rápido.", code: L, points: 1 },
    { text: "Prefiero entender cómo funciona antes de hablar.", code: W, points: 1 },
    { text: "Observo quién toma decisiones.", code: H, points: 1 },
    { text: "Trato de caer bien y generar confianza.", code: D, points: 1 },
  ]},
  { id: "q20", text: "Si cometes un error nuevo…", options: [
    { text: "Lo tomo como parte del juego y sigo.", code: L, points: 1 },
    { text: "Analizo qué falló para no repetirlo.", code: W, points: 1 },
    { text: "Me pregunto si era la mejor decisión desde el inicio.", code: H, points: 1 },
    { text: "Me afecta más si alguien se decepciona.", code: D, points: 1 },
  ]},
  { id: "q21", text: "Cuando tienes que empezar algo importante sin estar completamente preparado…", options: [
    { text: "Empiezo igual y ajusto en el camino.", code: L, points: 1 },
    { text: "Prefiero prepararme mejor antes de empezar.", code: W, points: 1 },
    { text: "Evalúo si realmente es el momento correcto para hacerlo.", code: H, points: 1 },
    { text: "Defino cómo mover a otros para avanzar.", code: D, points: 1 },
  ]},
  { id: "q22", text: "Si te dan una meta nueva sin muchas instrucciones…", options: [
    { text: "Me motiva. Me gusta el desafío.", code: L, points: 1 },
    { text: "Empiezo a hacerme preguntas para entenderla bien.", code: W, points: 1 },
    { text: "Evalúo si esa meta tiene sentido.", code: H, points: 1 },
    { text: "Me fijo cómo impacta a las personas involucradas.", code: D, points: 1 },
  ]},
  { id: "q23", text: "Cuando no tienes claridad total sobre una tarea…", options: [
    { text: "Avanzo igual, aunque no tenga toda la claridad.", code: L, points: 1 },
    { text: "Necesito ordenar todo antes de avanzar.", code: W, points: 1 },
    { text: "Evalúo si vale la pena hacerla ahora.", code: H, points: 2 },
    { text: "Busco hablar con alguien para entenderla mejor.", code: D, points: 1 },
  ]},
  { id: "q24", text: "Vas a contactar a alguien importante por primera vez. ¿Qué haces antes?", options: [
    { text: "Voy directo. Actúo aunque no tenga todo claro.", code: L, points: 1 },
    { text: "Busco información para entender mejor antes de actuar.", code: W, points: 1 },
    { text: "Evalúo si es la persona correcta antes de avanzar.", code: H, points: 1 },
    { text: "Pienso cómo iniciar la conversación para generar conexión.", code: D, points: 1 },
  ]},
];

/**
 * answers: array of {code, points} chosen per question.
 * Returns { scores, dominant, secondary }.
 */
export function computeResult(answers) {
  const scores = { leon: 0, lobo: 0, halcon: 0, delfin: 0 };
  answers.forEach((a) => {
    if (a && scores[a.code] !== undefined) scores[a.code] += a.points || 1;
  });
  const ordered = Object.entries(scores).sort((a, b) => b[1] - a[1]);
  return {
    scores,
    dominant: ordered[0][0],
    secondary: ordered[1][0],
  };
}

// Backward-compat helper still used by some imports.
export function computeArchetype(codes) {
  const fake = codes.map((c) => ({ code: c, points: 1 }));
  return computeResult(fake).dominant;
}
